import { ApiProperty } from '@nestjs/swagger';
import { ContractorRegionInterface } from '../interfaces/contractor-region.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { IsUUID } from 'class-validator';

export class ContractorRegionDto
  extends CommonEntityDto
  implements ContractorRegionInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  contractorId!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  regionId!: string;
}
